import React, { useState, useEffect } from "react";
import axios from "axios";

import { getUser, getIdToken, getClient } from "../../../../utils/storage";

import InnerLoader from "../../../InnerLoader";
import RequestCard from "./PushCard";
import {
  fetchCampaignStatuses,
  getMultiMediaCampaigns,
} from "../../../../services/dashboard-api";

const RequestsCards = (props) => {
  const { requests, setRequests, filter } = props;
  const [isLoading, setIsLoading] = useState(true);
  const [surveyStatus, setSurveyStatus] = useState([]);
  const params = {
    uid: getUser().uid,
    clientRef: getClient().clientRef,
  };
  const newParams = filter.sortField
    ? { ...params, sortField: filter.sortField, sortOrder: filter.sortOrder }
    : params;
  useEffect(() => {
    // axios
    //   .post(
    //     `${process.env.REACT_APP_API_BASE_URL}/versus_v2_get_requests`,
    //     newParams,
    //     { headers: { "content-type": "application/json" } }
    //   )
    //   .then(({ data }) => {
    //     setIsLoading(false);
    //     setRequests(data.requests);
    //   })
    //   .catch((error) => {
    //     //set isloading to false since the value is null
    //     setIsLoading(false);
    //     console.log("Error getting client requests", error);
    //   });

    //get requests
    const getRequests = async () => {
      try {
        const { data } = await getMultiMediaCampaigns(newParams);
        const requests = data?.campaigns;

        console.log("Requests fetched:", requests);
        setIsLoading(false);
        setRequests(requests);
      } catch (error) {
        setIsLoading(false);
        console.log("Error getting client requests", error);
      }
    };

    getRequests();

    //get campaign statuses
    const getCampaignStatuses = async () => {
      try {
        const { data } = await fetchCampaignStatuses();
        const campaignStatuses = data?.data;
        setSurveyStatus(campaignStatuses);
      } catch (error) {
        console.log("Error obtaining surveys statuses", error.message);
      }
    };

    getCampaignStatuses();
  }, [filter]);

  return (
    <div className="row has-cards wrap stretch">
      {isLoading ? (
        <InnerLoader />
      ) : (
        <RequestCard requests={requests} surveyStatus={surveyStatus} />
      )}
    </div>
  );
};

export default RequestsCards;
